import { Component } from '@angular/core';
import { RouterOutlet, RouterModule, Routes } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { DashboardBackGuardService } from './core/services/dashboard-back-guard.service.js';
import { IndexScriptsService } from './utils/index-scripts.service.js';
import { environment } from '../environments/environment.js';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MatIconModule, MatButtonModule, MatDividerModule, RouterModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'iDownsize-app';

  constructor(
    private indexScriptsService: IndexScriptsService,
    private dashboardBackGuard: DashboardBackGuardService,
  ) {}

  ngOnInit(): void {
    this.dashboardBackGuard.install();
    this.indexScriptsService.loadScripts();
    this.identifyAnalyticsUser();
  }

  private identifyAnalyticsUser(): void {
    if (!environment.production) return;
    const raw = localStorage.getItem('user');
    if (!raw) return;
    try {
      const user = JSON.parse(raw);
      if (user?.id) {
        window.mixpanel?.identify(String(user.id));
        window.mixpanel?.people?.set({ $email: user.email, $name: `${user.firstName} ${user.lastName}` });
      }
    } catch {
      // ignore malformed localStorage entry
    }
  }
}
